export interface CategorySection {
  heading: string;
  paragraph: string;
  bullets?: string[];
}

export interface CategoryFaq {
  q: string;
  a: string;
}

export interface CategoryContent {
  title: string;
  metaDescription: string;
  excerpt: string;
  intro: string;
  sections: CategorySection[];
  faq: CategoryFaq[];
  conclusion: string;
}

export interface CategoryArticle {
  slug: string;
  content: Record<string, CategoryContent>;
}

export const categoryArticlesB: CategoryArticle[] = [
  {
    slug: 'underwear',
    content: {
      en: {
        title: 'USFANS Spreadsheet Underwear: What to Check Before Buying',
        metaDescription: 'A focused guide to the underwear category in the USFANS spreadsheet — sizing, fabric and hygiene considerations before ordering.',
        excerpt: 'What to check about sizing, fabric and hygiene before buying underwear.',
        intro: 'Underwear is the one category where fit and fabric matter more than looks. Because it sits against your skin all day, getting the size and material right is essential for both comfort and hygiene.',
        sections: [
          {
            heading: 'What to Check Before Buying Underwear',
            paragraph: 'Comfort comes from the right combination of size, fabric and construction.',
            bullets: [
              'Confirm the sizing, since underwear sizing varies a lot',
              'Ask about the fabric and whether it is breathable',
              'Check the waistband and stitching in close-ups',
            ],
          },
          {
            heading: 'Fabric and Hygiene Considerations',
            paragraph: 'Breathable, natural fabrics are generally more comfortable for all-day wear. It is also worth confirming the return policy, since many sellers have strict rules for underwear.',
          },
        ],
        faq: [
          { q: 'How does underwear sizing work?', a: 'Sizing varies a lot between brands, so always check the measurements and compare them against underwear you already own.' },
          { q: 'What fabric should I look for?', a: 'Breathable, natural fabrics like cotton are usually the most comfortable for all-day wear, so ask the seller about the material.' },
          { q: 'Can I return underwear if it does not fit?', a: 'Many sellers have strict return policies for underwear, so confirm the policy before ordering.' },
        ],
        conclusion: 'Confirm the sizing, fabric and return policy, and the underwear category becomes a comfortable, low-risk purchase instead of a guess.',
      },
      es: {
        title: 'Ropa interior en el spreadsheet de USFANS: qué revisar antes de comprar',
        metaDescription: 'Una guía centrada en la categoría de ropa interior del spreadsheet de USFANS: tallaje, tejido e higiene antes de pedir.',
        excerpt: 'Qué revisar sobre tallaje, tejido e higiene antes de comprar ropa interior.',
        intro: 'La ropa interior es la categoría donde el ajuste y el tejido importan más que la apariencia. Como va pegada a la piel todo el día, acertar con la talla y el material es esencial para la comodidad y la higiene.',
        sections: [
          {
            heading: 'Qué revisar antes de comprar ropa interior',
            paragraph: 'La comodidad viene de la combinación correcta de talla, tejido y confección.',
            bullets: [
              'Confirma la talla, ya que el tallaje varía mucho',
              'Pregunta por el tejido y si es transpirable',
              'Revisa la cinturilla y las costuras en primeros planos',
            ],
          },
          {
            heading: 'Consideraciones de tejido e higiene',
            paragraph: 'Los tejidos naturales y transpirables suelen ser más cómodos para llevar todo el día. También conviene confirmar la política de devolución, ya que muchos vendedores tienen normas estrictas para la ropa interior.',
          },
        ],
        faq: [
          { q: '¿Cómo funciona el tallaje de la ropa interior?', a: 'El tallaje varía mucho entre marcas, así que revisa siempre las medidas y compáralas con ropa interior que ya tengas.' },
          { q: '¿Qué tejido debo buscar?', a: 'Los tejidos naturales y transpirables, como el algodón, suelen ser los más cómodos para todo el día, así que pregunta al vendedor por el material.' },
          { q: '¿Puedo devolver la ropa interior si no me queda?', a: 'Muchos vendedores tienen políticas de devolución estrictas para la ropa interior, así que confirma la política antes de pedir.' },
        ],
        conclusion: 'Confirma la talla, el tejido y la política de devolución, y la categoría de ropa interior se vuelve una compra cómoda y de bajo riesgo en lugar de una apuesta.',
      },
      fr: {
        title: 'Sous-vêtements dans le spreadsheet USFANS : quoi vérifier avant d\u2019acheter',
        metaDescription: 'Un guide ciblé sur la catégorie sous-vêtements du spreadsheet USFANS : taille, tissu et hygiène avant de commander.',
        excerpt: 'Quoi vérifier sur la taille, le tissu et l\u2019hygiène avant d\u2019acheter des sous-vêtements.',
        intro: 'Les sous-vêtements sont la catégorie où l\u2019ajustement et le tissu comptent plus que l\u2019apparence. Comme ils sont portés contre la peau toute la journée, trouver la bonne taille et la bonne matière est essentiel pour le confort et l\u2019hygiène.',
        sections: [
          {
            heading: 'Quoi vérifier avant d\u2019acheter des sous-vêtements',
            paragraph: 'Le confort vient de la bonne combinaison de taille, de tissu et de confection.',
            bullets: [
              'Confirmez la taille, car elle varie beaucoup',
              'Demandez le tissu et s\u2019il est respirant',
              'Vérifiez la ceinture et les coutures en gros plan',
            ],
          },
          {
            heading: 'Considérations de tissu et d\u2019hygiène',
            paragraph: 'Les tissus naturels et respirants sont généralement plus confortables à porter toute la journée. Il vaut aussi la peine de confirmer la politique de retour, car de nombreux vendeurs ont des règles strictes pour les sous-vêtements.',
          },
        ],
        faq: [
          { q: 'Comment fonctionnent les tailles de sous-vêtements ?', a: 'Les tailles varient beaucoup entre les marques, donc vérifiez toujours les mesures et comparez-les avec des sous-vêtements que vous possédez déjà.' },
          { q: 'Quel tissu rechercher ?', a: 'Les tissus naturels et respirants comme le coton sont généralement les plus confortables à porter toute la journée, donc demandez la matière au vendeur.' },
          { q: 'Puis-je retourner des sous-vêtements qui ne vont pas ?', a: 'De nombreux vendeurs ont des politiques de retour strictes pour les sous-vêtements, donc confirmez la politique avant de commander.' },
        ],
        conclusion: 'Confirmez la taille, le tissu et la politique de retour, et la catégorie sous-vêtements devient un achat confortable et à faible risque plutôt qu\u2019un pari.',
      },
      pl: {
        title: 'Bielizna w arkuszu USFANS: co sprawdzić przed zakupem',
        metaDescription: 'Przewodnik skupiony na kategorii bielizny w arkuszu USFANS: rozmiar, tkanina i higiena przed zamówieniem.',
        excerpt: 'Co sprawdzić w kwestii rozmiaru, tkaniny i higieny przed zakupem bielizny.',
        intro: 'Bielizna to kategoria, w której dopasowanie i tkanina znaczą więcej niż wygląd. Ponieważ nosi się ją przy skórze cały dzień, trafienie w rozmiar i materiał jest kluczowe dla wygody i higieny.',
        sections: [
          {
            heading: 'Co sprawdzić przed zakupem bielizny',
            paragraph: 'Wygoda bierze się z właściwego połączenia rozmiaru, tkaniny i wykonania.',
            bullets: [
              'Potwierdź rozmiar, bo rozmiarówka bardzo się różni',
              'Zapytaj o tkaninę i czy jest oddychająca',
              'Sprawdź gumkę i szwy na zbliżeniach',
            ],
          },
          {
            heading: 'Kwestie tkaniny i higieny',
            paragraph: 'Naturalne, oddychające tkaniny są zwykle wygodniejsze do noszenia przez cały dzień. Warto też potwierdzić politykę zwrotów, bo wielu sprzedawców ma surowe zasady dotyczące bielizny.',
          },
        ],
        faq: [
          { q: 'Jak działa rozmiarówka bielizny?', a: 'Rozmiary bardzo się różnią między markami, więc zawsze sprawdzaj wymiary i porównuj je z bielizną, którą już masz.' },
          { q: 'Jakiej tkaniny szukać?', a: 'Naturalne, oddychające tkaniny, jak bawełna, są zwykle najwygodniejsze na cały dzień, więc zapytaj sprzedawcę o materiał.' },
          { q: 'Czy mogę zwrócić bieliznę, jeśli nie pasuje?', a: 'Wielu sprzedawców ma surowe zasady zwrotów dla bielizny, więc potwierdź politykę przed zamówieniem.' },
        ],
        conclusion: 'Potwierdź rozmiar, tkaninę i politykę zwrotów, a kategoria bielizny stanie się wygodnym, niskiego ryzyka zakupem zamiast zgadywanki.',
      },
    },
  },
  {
    slug: 'jersey',
    content: {
      en: {
        title: 'USFANS Spreadsheet Jerseys: What to Check Before You Buy',
        metaDescription: 'A focused guide to the jerseys category in the USFANS spreadsheet — sizing, print and logo details before ordering.',
        excerpt: 'What to check about sizing, print and logo details before buying jerseys.',
        intro: 'Jerseys are statement pieces, so the details — numbers, names, logos and patches — are what people notice first. Getting the fit and the print right matters more than with a plain top.',
        sections: [
          {
            heading: 'What to Check Before Buying a Jersey',
            paragraph: 'A jersey has more detail than a regular shirt, so each part is worth a quick look.',
            bullets: [
              'Confirm the sizing and how the jersey is meant to fit',
              'Check the numbers, names and logos in close-up',
              'Ask about the fabric and whether it is breathable',
            ],
          },
          {
            heading: 'Details That Matter on Jerseys',
            paragraph: 'Pay attention to how the printing is applied and whether the patches are stitched or heat-pressed, since these details affect both looks and durability.',
          },
        ],
        faq: [
          { q: 'How should a jersey fit?', a: 'Jerseys can be loose or athletic, so confirm the intended fit and check the measurements before ordering.' },
          { q: 'Are the numbers and names stitched or printed?', a: 'Ask the seller, since stitching usually lasts longer than heat-pressed printing, and it affects how the jersey looks up close.' },
          { q: 'What fabric is the jersey?', a: 'Most jerseys use lightweight, breathable fabric, but it is worth confirming the material before you buy.' },
        ],
        conclusion: 'Confirm the fit, the print application and the fabric, and you will get a jersey that looks as good up close as it does in photos.',
      },
      es: {
        title: 'Camisetas deportivas en el spreadsheet de USFANS: qué revisar antes de comprar',
        metaDescription: 'Una guía centrada en la categoría de camisetas deportivas del spreadsheet de USFANS: tallaje, estampado y detalles del logo antes de pedir.',
        excerpt: 'Qué revisar sobre tallaje, estampado y detalles del logo antes de comprar camisetas deportivas.',
        intro: 'Las camisetas deportivas son prendas llamativas, así que los detalles — números, nombres, logos y parches — son lo primero que la gente nota. Acertar con el ajuste y el estampado importa más que con una camiseta lisa.',
        sections: [
          {
            heading: 'Qué revisar antes de comprar una camiseta deportiva',
            paragraph: 'Una camiseta deportiva tiene más detalle que una camiseta normal, así que cada parte merece un vistazo.',
            bullets: [
              'Confirma el tallaje y cómo se supone que sienta',
              'Revisa los números, nombres y logos en primer plano',
              'Pregunta por el tejido y si es transpirable',
            ],
          },
          {
            heading: 'Detalles que importan en las camisetas deportivas',
            paragraph: 'Fíjate en cómo se aplica el estampado y si los parches están cosidos o termopegados, ya que estos detalles afectan tanto la apariencia como la durabilidad.',
          },
        ],
        faq: [
          { q: '¿Cómo debe sentar una camiseta deportiva?', a: 'Puede ser holgada o atlética, así que confirma el ajuste previsto y revisa las medidas antes de pedir.' },
          { q: '¿Los números y nombres están cosidos o estampados?', a: 'Pregunta al vendedor, ya que el cosido suele durar más que el termopegado y afecta cómo se ve de cerca.' },
          { q: '¿De qué tejido es la camiseta deportiva?', a: 'La mayoría usa tejido ligero y transpirable, pero conviene confirmar el material antes de comprar.' },
        ],
        conclusion: 'Confirma el ajuste, la aplicación del estampado y el tejido, y conseguirás una camiseta deportiva que se vea tan bien de cerca como en las fotos.',
      },
      fr: {
        title: 'Maillots dans le spreadsheet USFANS : quoi vérifier avant d\u2019acheter',
        metaDescription: 'Un guide ciblé sur la catégorie maillots du spreadsheet USFANS : taille, impression et détails du logo avant de commander.',
        excerpt: 'Quoi vérifier sur la taille, l\u2019impression et les détails du logo avant d\u2019acheter un maillot.',
        intro: 'Les maillots sont des pièces fortes, donc les détails — numéros, noms, logos et écussons — sont ce que les gens remarquent en premier. Réussir la coupe et l\u2019impression compte plus que pour un haut uni.',
        sections: [
          {
            heading: 'Quoi vérifier avant d\u2019acheter un maillot',
            paragraph: 'Un maillot a plus de détails qu\u2019un t-shirt ordinaire, donc chaque partie mérite un coup d\u2019œil.',
            bullets: [
              'Confirmez la taille et la coupe prévue',
              'Vérifiez les numéros, noms et logos en gros plan',
              'Demandez le tissu et s\u2019il est respirant',
            ],
          },
          {
            heading: 'Les détails qui comptent sur un maillot',
            paragraph: 'Regardez comment l\u2019impression est appliquée et si les écussons sont cousus ou thermocollés, car ces détails influencent l\u2019apparence et la durabilité.',
          },
        ],
        faq: [
          { q: 'Comment doit tomber un maillot ?', a: 'Un maillot peut être ample ou athlétique, donc confirmez la coupe prévue et vérifiez les mesures avant de commander.' },
          { q: 'Les numéros et noms sont-ils cousus ou imprimés ?', a: 'Demandez au vendeur, car la couture dure généralement plus longtemps que le thermocollage et change l\u2019aspect de près.' },
          { q: 'De quel tissu est le maillot ?', a: 'La plupart utilisent un tissu léger et respirant, mais il vaut mieux confirmer la matière avant d\u2019acheter.' },
        ],
        conclusion: 'Confirmez la coupe, l\u2019application de l\u2019impression et le tissu, et vous obtiendrez un maillot aussi beau de près qu\u2019en photo.',
      },
      pl: {
        title: 'Koszulki sportowe w arkuszu USFANS: co sprawdzić przed zakupem',
        metaDescription: 'Przewodnik skupiony na kategorii koszulek sportowych w arkuszu USFANS: rozmiar, nadruk i detale logo przed zamówieniem.',
        excerpt: 'Co sprawdzić w kwestii rozmiaru, nadruku i detali logo przed zakupem koszulki sportowej.',
        intro: 'Koszulki sportowe to wyraziste ubrania, więc detale — numery, nazwiska, logo i naszywki — są tym, co ludzie zauważają najpierw. Trafienie w krój i nadruk ma większe znaczenie niż przy zwykłej koszulce.',
        sections: [
          {
            heading: 'Co sprawdzić przed zakupem koszulki sportowej',
            paragraph: 'Koszulka sportowa ma więcej detali niż zwykła, więc każda część zasługuje na rzut oka.',
            bullets: [
              'Potwierdź rozmiar i przewidziany krój',
              'Sprawdź numery, nazwiska i logo na zbliżeniach',
              'Zapytaj o tkaninę i czy jest oddychająca',
            ],
          },
          {
            heading: 'Detale, które mają znaczenie w koszulkach sportowych',
            paragraph: 'Zwróć uwagę, jak nakładany jest nadruk i czy naszywki są szyte czy termoprasowane, bo te detale wpływają na wygląd i trwałość.',
          },
        ],
        faq: [
          { q: 'Jak ma leżeć koszulka sportowa?', a: 'Może być luźna lub sportowa, więc potwierdź przewidziany krój i sprawdź wymiary przed zamówieniem.' },
          { q: 'Czy numery i nazwiska są szyte czy drukowane?', a: 'Zapytaj sprzedawcę, bo szycie zwykle trwa dłużej niż termoprasowanie i zmienia wygląd z bliska.' },
          { q: 'Z jakiej tkaniny jest koszulka sportowa?', a: 'Większość używa lekkiej, oddychającej tkaniny, ale warto potwierdzić materiał przed zakupem.' },
        ],
        conclusion: 'Potwierdź krój, sposób nakładania nadruku i tkaninę, a dostaniesz koszulkę sportową, która wygląda tak dobrze z bliska, jak na zdjęciach.',
      },
    },
  },
  {
    slug: 'accessories',
    content: {
      en: {
        title: 'USFANS Spreadsheet Accessories: What to Check Before Buying',
        metaDescription: 'A focused guide to the accessories category in the USFANS spreadsheet — material, durability and what to verify before ordering.',
        excerpt: 'What to check about material and durability before buying accessories.',
        intro: 'Accessories like watches, sunglasses and small leather goods are easy to underestimate, but they get daily wear and tear. Checking the material and build quality up front prevents disappointment later.',
        sections: [
          {
            heading: 'What to Check Before Buying Accessories',
            paragraph: 'Small items have small details, and those details determine how long they last.',
            bullets: [
              'Ask about the actual material, not just the look',
              'Check hardware and clasps in close-up photos',
              'Confirm the dimensions so the size is right',
            ],
          },
          {
            heading: 'Durability Considerations',
            paragraph: 'The difference between a durable accessory and a fragile one is usually in the materials and hardware. Ask specific questions rather than relying on polished photos.',
          },
        ],
        faq: [
          { q: 'What material is the accessory made of?', a: 'Ask the seller directly, since listings can be vague. The real material determines how the item wears and how long it lasts.' },
          { q: 'How do I check the build quality?', a: 'Request close-up photos of hardware, clasps and edges, which reveal more about quality than a single distance shot.' },
          { q: 'Are the dimensions what I expect?', a: 'Confirm the measurements before ordering, since accessories can look larger or smaller in photos than they really are.' },
        ],
        conclusion: 'Confirm the material, build quality and dimensions, and accessories become a reliable part of your wardrobe instead of a gamble.',
      },
      es: {
        title: 'Accesorios en el spreadsheet de USFANS: qué revisar antes de comprar',
        metaDescription: 'Una guía centrada en la categoría de accesorios del spreadsheet de USFANS: material, durabilidad y qué verificar antes de pedir.',
        excerpt: 'Qué revisar sobre material y durabilidad antes de comprar accesorios.',
        intro: 'Los accesorios como relojes, gafas de sol y artículos de piel pequeños son fáciles de subestimar, pero reciben uso y desgaste diario. Revisar el material y la calidad de fabricación de antemano evita decepciones.',
        sections: [
          {
            heading: 'Qué revisar antes de comprar accesorios',
            paragraph: 'Los artículos pequeños tienen detalles pequeños, y esos detalles determinan cuánto duran.',
            bullets: [
              'Pregunta por el material real, no solo el aspecto',
              'Revisa herrajes y cierres en fotos cercanas',
              'Confirma las dimensiones para que el tamaño sea el correcto',
            ],
          },
          {
            heading: 'Consideraciones de durabilidad',
            paragraph: 'La diferencia entre un accesorio duradero y uno frágil suele estar en los materiales y herrajes. Haz preguntas concretas en lugar de fiarte de fotos pulidas.',
          },
        ],
        faq: [
          { q: '¿De qué material es el accesorio?', a: 'Pregunta directamente al vendedor, ya que los anuncios pueden ser vagos. El material real determina cómo se desgasta y cuánto dura.' },
          { q: '¿Cómo compruebo la calidad de fabricación?', a: 'Pide fotos cercanas de herrajes, cierres y bordes, que revelan más de la calidad que una sola foto a distancia.' },
          { q: '¿Las dimensiones son las que espero?', a: 'Confirma las medidas antes de pedir, ya que los accesorios pueden parecer más grandes o pequeños en las fotos de lo que son en realidad.' },
        ],
        conclusion: 'Confirma el material, la calidad de fabricación y las dimensiones, y los accesorios se vuelven una parte fiable de tu armario en lugar de una apuesta.',
      },
      fr: {
        title: 'Accessoires dans le spreadsheet USFANS : quoi vérifier avant d\u2019acheter',
        metaDescription: 'Un guide ciblé sur la catégorie accessoires du spreadsheet USFANS : matière, durabilité et quoi vérifier avant de commander.',
        excerpt: 'Quoi vérifier sur la matière et la durabilité avant d\u2019acheter des accessoires.',
        intro: 'Les accessoires comme les montres, lunettes de soleil et petits articles en cuir sont faciles à sous-estimer, mais ils subissent une usure quotidienne. Vérifier la matière et la qualité de fabrication à l\u2019avance évite les déceptions.',
        sections: [
          {
            heading: 'Quoi vérifier avant d\u2019acheter des accessoires',
            paragraph: 'Les petits articles ont de petits détails, et ces détails déterminent leur durée de vie.',
            bullets: [
              'Demandez la matière réelle, pas seulement l\u2019apparence',
              'Vérifiez les finitions et fermoirs en gros plan',
              'Confirmez les dimensions pour être sûr de la taille',
            ],
          },
          {
            heading: 'Considérations de durabilité',
            paragraph: 'La différence entre un accessoire durable et un fragile tient souvent aux matières et aux finitions. Posez des questions précises plutôt que de vous fier à des photos soignées.',
          },
        ],
        faq: [
          { q: 'De quelle matière est l\u2019accessoire ?', a: 'Demandez directement au vendeur, car les annonces peuvent être vagues. La matière réelle détermine l\u2019usure et la durée de vie.' },
          { q: 'Comment vérifier la qualité de fabrication ?', a: 'Demandez des photos en gros plan des finitions, fermoirs et bords, qui en disent plus qu\u2019une seule photo de loin.' },
          { q: 'Les dimensions sont-elles celles attendues ?', a: 'Confirmez les mesures avant de commander, car les accessoires peuvent paraître plus grands ou plus petits en photo qu\u2019en réalité.' },
        ],
        conclusion: 'Confirmez la matière, la qualité de fabrication et les dimensions, et les accessoires deviennent un élément fiable de votre garde-robe plutôt qu\u2019un pari.',
      },
      pl: {
        title: 'Akcesoria w arkuszu USFANS: co sprawdzić przed zakupem',
        metaDescription: 'Przewodnik skupiony na kategorii akcesoriów w arkuszu USFANS: materiał, trwałość i co zweryfikować przed zamówieniem.',
        excerpt: 'Co sprawdzić w kwestii materiału i trwałości przed zakupem akcesoriów.',
        intro: 'Akcesoria, takie jak zegarki, okulary przeciwsłoneczne i drobne wyroby skórzane, łatwo zlekceważyć, ale są noszone i zużywane codziennie. Sprawdzenie materiału i jakości wykonania z wyprzedzeniem zapobiega rozczarowaniom.',
        sections: [
          {
            heading: 'Co sprawdzić przed zakupem akcesoriów',
            paragraph: 'Małe przedmioty mają małe detale, a te detale decydują o ich trwałości.',
            bullets: [
              'Zapytaj o rzeczywisty materiał, nie tylko wygląd',
              'Sprawdź okucia i zapięcia na zbliżeniach',
              'Potwierdź wymiary, aby rozmiar się zgadzał',
            ],
          },
          {
            heading: 'Kwestie trwałości',
            paragraph: 'Różnica między trwałym a kruchym akcesorium zwykle tkwi w materiałach i okuć. Zadawaj konkretne pytania zamiast polegać na wypolerowanych zdjęciach.',
          },
        ],
        faq: [
          { q: 'Z jakiego materiału jest akcesorium?', a: 'Zapytaj sprzedawcę wprost, bo ogłoszenia bywają niejasne. Rzeczywisty materiał decyduje o zużyciu i trwałości.' },
          { q: 'Jak sprawdzić jakość wykonania?', a: 'Poproś o zbliżenia okuć, zapięć i krawędzi, które mówią więcej o jakości niż jedno zdjęcie z daleka.' },
          { q: 'Czy wymiary są takie, jak oczekuję?', a: 'Potwierdź wymiary przed zamówieniem, bo akcesoria mogą wyglądać na zdjęciach na większe lub mniejsze, niż są w rzeczywistości.' },
        ],
        conclusion: 'Potwierdź materiał, jakość wykonania i wymiary, a akcesoria staną się niezawodną częścią garderoby zamiast hazardu.',
      },
    },
  },
  {
    slug: 'bags',
    content: {
      en: {
        title: 'USFANS Spreadsheet Bags: What to Check Before You Buy',
        metaDescription: 'A focused guide to the bags category in the USFANS spreadsheet — size, material and hardware before ordering.',
        excerpt: 'What to check about size, material and hardware before buying bags.',
        intro: 'Bags work hard and carry your everyday essentials, so they need to be the right size and built to last. Checking the material, hardware and dimensions up front is well worth the time.',
        sections: [
          {
            heading: 'What to Check Before Buying a Bag',
            paragraph: 'A bag has to fit your needs as much as your style, so start with the practical details.',
            bullets: [
              'Confirm the dimensions and how much it holds',
              'Ask about the material and whether it is durable',
              'Check zippers, straps and hardware in close-ups',
            ],
          },
          {
            heading: 'Material and Hardware Quality',
            paragraph: 'Zippers and straps are the first parts to fail on a bag, so a close look at the hardware tells you a lot about how long the bag will last.',
          },
        ],
        faq: [
          { q: 'How big is the bag?', a: 'Confirm the dimensions and capacity, since a bag that looks right in photos may be smaller or larger in real life.' },
          { q: 'What material is the bag?', a: 'Ask the seller, because the material determines durability, weight and how the bag holds up to daily use.' },
          { q: 'Are the zippers and straps durable?', a: 'Request close-up photos of the hardware, since zippers and straps are usually the first things to wear out.' },
        ],
        conclusion: 'Confirm the size, material and hardware, and you will get a bag that works for your daily life instead of one that only looks good online.',
      },
      es: {
        title: 'Bolsos en el spreadsheet de USFANS: qué revisar antes de comprar',
        metaDescription: 'Una guía centrada en la categoría de bolsos del spreadsheet de USFANS: tamaño, material y herrajes antes de pedir.',
        excerpt: 'Qué revisar sobre tamaño, material y herrajes antes de comprar bolsos.',
        intro: 'Los bolsos trabajan duro y llevan tus cosas esenciales a diario, así que deben tener el tamaño correcto y estar hechos para durar. Revisar el material, los herrajes y las dimensiones de antemano vale la pena.',
        sections: [
          {
            heading: 'Qué revisar antes de comprar un bolso',
            paragraph: 'Un bolso tiene que adaptarse a tus necesidades tanto como a tu estilo, así que empieza por los detalles prácticos.',
            bullets: [
              'Confirma las dimensiones y cuánto cabe',
              'Pregunta por el material y si es duradero',
              'Revisa cremalleras, correas y herrajes en primeros planos',
            ],
          },
          {
            heading: 'Calidad del material y los herrajes',
            paragraph: 'Las cremalleras y las correas son las primeras partes que fallan en un bolso, así que mirar de cerca los herrajes dice mucho de cuánto durará.',
          },
        ],
        faq: [
          { q: '¿Qué tamaño tiene el bolso?', a: 'Confirma las dimensiones y la capacidad, ya que un bolso que se ve bien en fotos puede ser más pequeño o más grande en la vida real.' },
          { q: '¿De qué material es el bolso?', a: 'Pregunta al vendedor, porque el material determina la durabilidad, el peso y cómo aguanta el uso diario.' },
          { q: '¿Son duraderas las cremalleras y correas?', a: 'Pide fotos cercanas de los herrajes, ya que las cremalleras y correas suelen ser lo primero que se desgasta.' },
        ],
        conclusion: 'Confirma el tamaño, el material y los herrajes, y conseguirás un bolso que funcione en tu día a día en lugar de uno que solo se ve bien en línea.',
      },
      fr: {
        title: 'Sacs dans le spreadsheet USFANS : quoi vérifier avant d\u2019acheter',
        metaDescription: 'Un guide ciblé sur la catégorie sacs du spreadsheet USFANS : taille, matière et finitions avant de commander.',
        excerpt: 'Quoi vérifier sur la taille, la matière et les finitions avant d\u2019acheter un sac.',
        intro: 'Les sacs travaillent dur et transportent vos essentiels au quotidien, ils doivent donc avoir la bonne taille et être faits pour durer. Vérifier la matière, les finitions et les dimensions à l\u2019avance en vaut la peine.',
        sections: [
          {
            heading: 'Quoi vérifier avant d\u2019acheter un sac',
            paragraph: 'Un sac doit convenir à vos besoins autant qu\u2019à votre style, donc commencez par les détails pratiques.',
            bullets: [
              'Confirmez les dimensions et la contenance',
              'Demandez la matière et si elle est durable',
              'Vérifiez fermetures, sangles et finitions en gros plan',
            ],
          },
          {
            heading: 'Qualité de la matière et des finitions',
            paragraph: 'Les fermetures et les sangles sont les premières à lâcher sur un sac, donc regarder les finitions de près en dit long sur sa durée de vie.',
          },
        ],
        faq: [
          { q: 'Quelle est la taille du sac ?', a: 'Confirmez les dimensions et la contenance, car un sac qui semble bien en photo peut être plus petit ou plus grand en vrai.' },
          { q: 'De quelle matière est le sac ?', a: 'Demandez au vendeur, car la matière détermine la durabilité, le poids et la tenue à l\u2019usage quotidien.' },
          { q: 'Les fermetures et sangles sont-elles durables ?', a: 'Demandez des photos en gros plan des finitions, car les fermetures et sangles sont souvent les premières à s\u2019user.' },
        ],
        conclusion: 'Confirmez la taille, la matière et les finitions, et vous obtiendrez un sac qui convient à votre quotidien plutôt qu\u2019un simple bel objet en ligne.',
      },
      pl: {
        title: 'Torby w arkuszu USFANS: co sprawdzić przed zakupem',
        metaDescription: 'Przewodnik skupiony na kategorii toreb w arkuszu USFANS: rozmiar, materiał i okucia przed zamówieniem.',
        excerpt: 'Co sprawdzić w kwestii rozmiaru, materiału i okuć przed zakupem torby.',
        intro: 'Torby ciężko pracują i niosą Twoje codzienne rzeczy, więc muszą mieć właściwy rozmiar i być zrobione na lata. Sprawdzenie materiału, okuć i wymiarów z wyprzedzeniem jest tego warte.',
        sections: [
          {
            heading: 'Co sprawdzić przed zakupem torby',
            paragraph: 'Torba musi pasować do Twoich potrzeb tak samo jak do stylu, więc zacznij od praktycznych detali.',
            bullets: [
              'Potwierdź wymiary i pojemność',
              'Zapytaj o materiał i czy jest trwały',
              'Sprawdź zamki, paski i okucia na zbliżeniach',
            ],
          },
          {
            heading: 'Jakość materiału i okuć',
            paragraph: 'Zamki i paski to pierwsze elementy, które psują się w torbie, więc przyjrzenie się okuć z bliska wiele mówi o trwałości.',
          },
        ],
        faq: [
          { q: 'Jaki rozmiar ma torba?', a: 'Potwierdź wymiary i pojemność, bo torba, która dobrze wygląda na zdjęciach, może być w rzeczywistości mniejsza lub większa.' },
          { q: 'Z jakiego materiału jest torba?', a: 'Zapytaj sprzedawcę, bo materiał decyduje o trwałości, wadze i odporności na codzienne użytkowanie.' },
          { q: 'Czy zamki i paski są trwałe?', a: 'Poproś o zbliżenia okuć, bo zamki i paski zwykle zużywają się jako pierwsze.' },
        ],
        conclusion: 'Potwierdź rozmiar, materiał i okucia, a dostaniesz torbę, która sprawdzi się na co dzień, zamiast takiej, która dobrze wygląda tylko online.',
      },
    },
  },
  {
    slug: 'belts',
    content: {
      en: {
        title: 'USFANS Spreadsheet Belts: What to Check Before Buying',
        metaDescription: 'A focused guide to the belts category in the USFANS spreadsheet — sizing, material and buckle quality before ordering.',
        excerpt: 'What to check about sizing, material and buckle quality before buying belts.',
        intro: 'Belts are simple, but a belt that is the wrong length or made from the wrong material is frustrating to use. Sizing and material are the two things to get right from the start.',
        sections: [
          {
            heading: 'What to Check Before Buying a Belt',
            paragraph: 'A belt needs to fit your waist and survive daily wear, so check the practical details.',
            bullets: [
              'Confirm the length and how it matches your waist size',
              'Ask whether the leather is genuine or synthetic',
              'Check the buckle and the holes in close-up',
            ],
          },
          {
            heading: 'Sizing and Material Considerations',
            paragraph: 'Belt sizing is often measured differently, so always confirm the length rather than relying on a generic size label. The material determines how the belt ages.',
          },
        ],
        faq: [
          { q: 'How do I choose the right belt size?', a: 'Measure an existing belt from the buckle to the hole you use most, and compare it against the listed length.' },
          { q: 'Is the belt genuine leather?', a: 'Ask the seller directly, since listings are not always clear, and the material determines how the belt wears over time.' },
          { q: 'Should I check the buckle quality?', a: 'Yes. A close-up of the buckle and the holes helps you judge whether the finishing is clean before you order.' },
        ],
        conclusion: 'Confirm the length, material and buckle, and a belt becomes a dependable daily accessory rather than a sizing guess.',
      },
      es: {
        title: 'Cinturones en el spreadsheet de USFANS: qué revisar antes de comprar',
        metaDescription: 'Una guía centrada en la categoría de cinturones del spreadsheet de USFANS: tallaje, material y calidad de la hebilla antes de pedir.',
        excerpt: 'Qué revisar sobre tallaje, material y calidad de la hebilla antes de comprar cinturones.',
        intro: 'Los cinturones son simples, pero uno con el largo equivocado o del material incorrecto es frustrante de usar. El tallaje y el material son las dos cosas que hay que acertar desde el principio.',
        sections: [
          {
            heading: 'Qué revisar antes de comprar un cinturón',
            paragraph: 'Un cinturón debe ajustarse a tu cintura y sobrevivir al uso diario, así que revisa los detalles prácticos.',
            bullets: [
              'Confirma el largo y cómo se ajusta a tu cintura',
              'Pregunta si el cuero es genuino o sintético',
              'Revisa la hebilla y los agujeros en primer plano',
            ],
          },
          {
            heading: 'Consideraciones de tallaje y material',
            paragraph: 'El tallaje de cinturones se mide a menudo de forma distinta, así que confirma siempre el largo en lugar de fiarte de una etiqueta genérica. El material determina cómo envejece.',
          },
        ],
        faq: [
          { q: '¿Cómo elijo la talla correcta de cinturón?', a: 'Mide un cinturón que ya tengas desde la hebilla hasta el agujero que más uses y compáralo con el largo indicado.' },
          { q: '¿El cinturón es cuero genuino?', a: 'Pregunta directamente al vendedor, ya que los anuncios no siempre son claros, y el material determina cómo se desgasta con el tiempo.' },
          { q: '¿Debo revisar la calidad de la hebilla?', a: 'Sí. Un primer plano de la hebilla y los agujeros te ayuda a juzgar si el acabado es limpio antes de pedir.' },
        ],
        conclusion: 'Confirma el largo, el material y la hebilla, y un cinturón se vuelve un accesorio diario fiable en lugar de una apuesta de talla.',
      },
      fr: {
        title: 'Ceintures dans le spreadsheet USFANS : quoi vérifier avant d\u2019acheter',
        metaDescription: 'Un guide ciblé sur la catégorie ceintures du spreadsheet USFANS : taille, matière et qualité de la boucle avant de commander.',
        excerpt: 'Quoi vérifier sur la taille, la matière et la qualité de la boucle avant d\u2019acheter une ceinture.',
        intro: 'Les ceintures sont simples, mais une ceinture trop longue ou dans la mauvaise matière est frustrante à utiliser. La taille et la matière sont les deux choses à réussir dès le départ.',
        sections: [
          {
            heading: 'Quoi vérifier avant d\u2019acheter une ceinture',
            paragraph: 'Une ceinture doit s\u2019ajuster à votre taille et résister à l\u2019usage quotidien, donc vérifiez les détails pratiques.',
            bullets: [
              'Confirmez la longueur et la correspondance avec votre taille',
              'Demandez si le cuir est véritable ou synthétique',
              'Vérifiez la boucle et les trous en gros plan',
            ],
          },
          {
            heading: 'Considérations de taille et de matière',
            paragraph: 'La taille des ceintures est souvent mesurée différemment, donc confirmez toujours la longueur plutôt que de vous fier à une étiquette générique. La matière détermine le vieillissement.',
          },
        ],
        faq: [
          { q: 'Comment choisir la bonne taille de ceinture ?', a: 'Mesurez une ceinture existante de la boucle au trou que vous utilisez le plus, et comparez avec la longueur indiquée.' },
          { q: 'La ceinture est-elle en vrai cuir ?', a: 'Demandez directement au vendeur, car les annonces ne sont pas toujours claires, et la matière détermine l\u2019usure dans le temps.' },
          { q: 'Dois-je vérifier la qualité de la boucle ?', a: 'Oui. Un gros plan de la boucle et des trous vous aide à juger si la finition est propre avant de commander.' },
        ],
        conclusion: 'Confirmez la longueur, la matière et la boucle, et une ceinture devient un accessoire quotidien fiable plutôt qu\u2019un pari de taille.',
      },
      pl: {
        title: 'Paski w arkuszu USFANS: co sprawdzić przed zakupem',
        metaDescription: 'Przewodnik skupiony na kategorii pasków w arkuszu USFANS: rozmiar, materiał i jakość klamry przed zamówieniem.',
        excerpt: 'Co sprawdzić w kwestii rozmiaru, materiału i jakości klamry przed zakupem paska.',
        intro: 'Paski są proste, ale pasek o złej długości lub ze złego materiału jest frustrujący w użyciu. Rozmiar i materiał to dwie rzeczy, które trzeba trafić od samego początku.',
        sections: [
          {
            heading: 'Co sprawdzić przed zakupem paska',
            paragraph: 'Pasek musi pasować do talii i przetrwać codzienne użytkowanie, więc sprawdź praktyczne detale.',
            bullets: [
              'Potwierdź długość i dopasowanie do talii',
              'Zapytaj, czy skóra jest prawdziwa, czy syntetyczna',
              'Sprawdź klamrę i dziurki na zbliżeniu',
            ],
          },
          {
            heading: 'Kwestie rozmiaru i materiału',
            paragraph: 'Rozmiary pasków bywają mierzone różnie, więc zawsze potwierdź długość zamiast polegać na ogólnej etykiecie. Materiał decyduje o tym, jak pasek się starzeje.',
          },
        ],
        faq: [
          { q: 'Jak wybrać właściwy rozmiar paska?', a: 'Zmierz pasek, który już masz, od klamry do najczęściej używanej dziurki i porównaj z podaną długością.' },
          { q: 'Czy pasek jest z prawdziwej skóry?', a: 'Zapytaj sprzedawcę wprost, bo ogłoszenia nie zawsze są jasne, a materiał decyduje o zużyciu z czasem.' },
          { q: 'Czy sprawdzać jakość klamry?', a: 'Tak. Zbliżenie klamry i dziurek pomaga ocenić, czy wykończenie jest czyste przed zamówieniem.' },
        ],
        conclusion: 'Potwierdź długość, materiał i klamrę, a pasek stanie się niezawodnym codziennym dodatkiem zamiast zgadywanki rozmiarowej.',
      },
    },
  },
  {
    slug: 'perfumes',
    content: {
      en: {
        title: 'USFANS Spreadsheet Perfumes: What to Check Before Buying',
        metaDescription: 'A focused guide to the perfumes category in the USFANS spreadsheet — authenticity, packaging and what to verify before ordering.',
        excerpt: 'What to check about authenticity and packaging before buying perfumes.',
        intro: 'Perfume is a personal purchase, and because it is a consumable product, authenticity and packaging matter a lot. A little careful checking helps you avoid a disappointing or counterfeit bottle.',
        sections: [
          {
            heading: 'What to Check Before Buying Perfume',
            paragraph: 'The details on the bottle and box often reveal whether a fragrance is what it claims to be.',
            bullets: [
              'Ask whether the item is new, sealed and in original packaging',
              'Check batch codes and labels in close-up photos',
              'Confirm the bottle size and concentration',
            ],
          },
          {
            heading: 'Authenticity and Packaging',
            paragraph: 'Sealed, original packaging and matching batch codes are good signs. Be cautious with unusually low prices or vague descriptions, and verify from a current, official source when in doubt.',
          },
        ],
        faq: [
          { q: 'Is the perfume authentic?', a: 'We are an independent resource and cannot verify authenticity. Check the packaging, batch codes and price, and verify from a current, official source when in doubt.' },
          { q: 'Should the perfume come sealed?', a: 'A new fragrance is usually sealed and in its original box, so confirm this with the seller before ordering.' },
          { q: 'Why does the price matter?', a: 'A price that is far below normal is worth treating with caution, since it can be a sign of a counterfeit or grey-market product.' },
        ],
        conclusion: 'Check authenticity, packaging and price, and the perfume category becomes a safer purchase rather than a blind gamble on a bottle.',
      },
      es: {
        title: 'Perfumes en el spreadsheet de USFANS: qué revisar antes de comprar',
        metaDescription: 'Una guía centrada en la categoría de perfumes del spreadsheet de USFANS: autenticidad, empaquetado y qué verificar antes de pedir.',
        excerpt: 'Qué revisar sobre autenticidad y empaquetado antes de comprar perfumes.',
        intro: 'El perfume es una compra personal y, al ser un producto consumible, la autenticidad y el empaquetado importan mucho. Un poco de revisión cuidadosa te ayuda a evitar un frasco decepcionante o falso.',
        sections: [
          {
            heading: 'Qué revisar antes de comprar perfume',
            paragraph: 'Los detalles del frasco y la caja suelen revelar si una fragancia es lo que dice ser.',
            bullets: [
              'Pregunta si el artículo es nuevo, sellado y en empaque original',
              'Revisa los códigos de lote y las etiquetas en fotos cercanas',
              'Confirma el tamaño del frasco y la concentración',
            ],
          },
          {
            heading: 'Autenticidad y empaquetado',
            paragraph: 'El empaque original sellado y los códigos de lote que coinciden son buenas señales. Desconfía de precios inusualmente bajos o descripciones vagas, y verifica desde una fuente actual y oficial ante la duda.',
          },
        ],
        faq: [
          { q: '¿El perfume es auténtico?', a: 'Somos un recurso independiente y no podemos verificar la autenticidad. Revisa el empaquetado, los códigos de lote y el precio, y verifica desde una fuente actual y oficial ante la duda.' },
          { q: '¿El perfume debería venir sellado?', a: 'Una fragancia nueva suele estar sellada y en su caja original, así que confírmalo con el vendedor antes de pedir.' },
          { q: '¿Por qué importa el precio?', a: 'Un precio muy por debajo de lo normal merece cautela, ya que puede ser señal de un producto falso o de mercado gris.' },
        ],
        conclusion: 'Revisa la autenticidad, el empaquetado y el precio, y la categoría de perfumes se vuelve una compra más segura en lugar de una apuesta a ciegas.',
      },
      fr: {
        title: 'Parfums dans le spreadsheet USFANS : quoi vérifier avant d\u2019acheter',
        metaDescription: 'Un guide ciblé sur la catégorie parfums du spreadsheet USFANS : authenticité, emballage et quoi vérifier avant de commander.',
        excerpt: 'Quoi vérifier sur l\u2019authenticité et l\u2019emballage avant d\u2019acheter un parfum.',
        intro: 'Le parfum est un achat personnel et, comme c\u2019est un produit consommable, l\u2019authenticité et l\u2019emballage comptent beaucoup. Un peu de vérification attentive vous aide à éviter un flacon décevant ou contrefait.',
        sections: [
          {
            heading: 'Quoi vérifier avant d\u2019acheter un parfum',
            paragraph: 'Les détails du flacon et de la boîte révèlent souvent si un parfum est bien ce qu\u2019il prétend être.',
            bullets: [
              'Demandez si l\u2019article est neuf, scellé et dans son emballage d\u2019origine',
              'Vérifiez les codes de lot et les étiquettes en gros plan',
              'Confirmez la taille du flacon et la concentration',
            ],
          },
          {
            heading: 'Authenticité et emballage',
            paragraph: 'Un emballage d\u2019origine scellé et des codes de lot cohérents sont de bons signes. Méfiez-vous des prix anormalement bas ou des descriptions vagues, et vérifiez auprès d\u2019une source actuelle et officielle en cas de doute.',
          },
        ],
        faq: [
          { q: 'Le parfum est-il authentique ?', a: 'Nous sommes une ressource indépendante et ne pouvons pas vérifier l\u2019authenticité. Vérifiez l\u2019emballage, les codes de lot et le prix, et confirmez auprès d\u2019une source actuelle et officielle en cas de doute.' },
          { q: 'Le parfum doit-il être scellé ?', a: 'Un parfum neuf est généralement scellé et dans sa boîte d\u2019origine, donc confirmez-le avec le vendeur avant de commander.' },
          { q: 'Pourquoi le prix compte-t-il ?', a: 'Un prix bien inférieur à la normale mérite de la prudence, car il peut signaler un produit contrefait ou du marché gris.' },
        ],
        conclusion: 'Vérifiez l\u2019authenticité, l\u2019emballage et le prix, et la catégorie parfums devient un achat plus sûr plutôt qu\u2019un pari à l\u2019aveugle.',
      },
      pl: {
        title: 'Perfumy w arkuszu USFANS: co sprawdzić przed zakupem',
        metaDescription: 'Przewodnik skupiony na kategorii perfum w arkuszu USFANS: autentyczność, opakowanie i co zweryfikować przed zamówieniem.',
        excerpt: 'Co sprawdzić w kwestii autentyczności i opakowania przed zakupem perfum.',
        intro: 'Perfumy to zakup osobisty, a ponieważ to produkt zużywalny, autentyczność i opakowanie mają duże znaczenie. Odrobina uważnego sprawdzenia pomaga uniknąć rozczarowującego lub podrobionego flakonu.',
        sections: [
          {
            heading: 'Co sprawdzić przed zakupem perfum',
            paragraph: 'Detale flakonu i pudełka często zdradzają, czy zapach jest tym, za co się podaje.',
            bullets: [
              'Zapytaj, czy produkt jest nowy, zapieczętowany i w oryginalnym opakowaniu',
              'Sprawdź kody partii i etykiety na zbliżeniach',
              'Potwierdź rozmiar flakonu i stężenie',
            ],
          },
          {
            heading: 'Autentyczność i opakowanie',
            paragraph: 'Zapieczętowane oryginalne opakowanie i zgodne kody partii to dobre sygnały. Uważaj na wyjątkowo niskie ceny lub niejasne opisy, a w razie wątpliwości weryfikuj z aktualnego, oficjalnego źródła.',
          },
        ],
        faq: [
          { q: 'Czy perfumy są autentyczne?', a: 'Jesteśmy niezależnym zasobem i nie możemy zweryfikować autentyczności. Sprawdź opakowanie, kody partii i cenę, a w razie wątpliwości potwierdź z aktualnego, oficjalnego źródła.' },
          { q: 'Czy perfumy powinny być zapieczętowane?', a: 'Nowy zapach zwykle jest zapieczętowany i w oryginalnym pudełku, więc potwierdź to ze sprzedawcą przed zamówieniem.' },
          { q: 'Dlaczego cena ma znaczenie?', a: 'Cena znacznie poniżej normy zasługuje na ostrożność, bo może sygnalizować produkt podrobiony lub z szarej strefy.' },
        ],
        conclusion: 'Sprawdź autentyczność, opakowanie i cenę, a kategoria perfum stanie się bezpieczniejszym zakupem zamiast ślepego hazardu na flakon.',
      },
    },
  },
  {
    slug: 'other',
    content: {
      en: {
        title: 'USFANS Spreadsheet Other Stuff: What to Check Before Buying',
        metaDescription: 'A focused guide to the other stuff category in the USFANS spreadsheet — how to evaluate less-common items and verify details before ordering.',
        excerpt: 'How to evaluate less-common items and verify details before buying.',
        intro: 'The "other stuff" category is a catch-all for items that do not fit neatly elsewhere. Because it is so varied, the same clear checks — material, condition, sizing and price — become even more important.',
        sections: [
          {
            heading: 'What to Check Before Buying',
            paragraph: 'With varied items, a consistent checklist is your best tool.',
            bullets: [
              'Clarify exactly what is included in the listing',
              'Ask about material, condition and dimensions',
              'Compare the price against similar items',
            ],
          },
          {
            heading: 'Evaluating Less-Common Items',
            paragraph: 'When an item is unusual, vague descriptions are a bigger risk. Ask direct questions and request clear photos before committing, since you have fewer reference points to rely on.',
          },
        ],
        faq: [
          { q: 'How do I evaluate an unusual item?', a: 'Use the same checklist as any purchase: clarify what is included, ask about material and condition, and compare prices.' },
          { q: 'Should I ask for more photos?', a: 'Yes. Clear, specific photos are especially helpful for less-common items where you have fewer points of reference.' },
          { q: 'What if the description is vague?', a: 'Treat a vague description as a reason to ask more questions before ordering, rather than assuming the best.' },
        ],
        conclusion: 'Apply the same careful checks to the "other stuff" category, and even unfamiliar items become a confident purchase rather than a leap of faith.',
      },
      es: {
        title: 'Otras cosas en el spreadsheet de USFANS: qué revisar antes de comprar',
        metaDescription: 'Una guía centrada en la categoría de otras cosas del spreadsheet de USFANS: cómo evaluar artículos menos comunes y verificar detalles antes de pedir.',
        excerpt: 'Cómo evaluar artículos menos comunes y verificar detalles antes de comprar.',
        intro: 'La categoría de "otras cosas" es un cajón de sastre para artículos que no encajan en ningún otro sitio. Como es tan variada, las mismas comprobaciones claras — material, estado, talla y precio — se vuelven aún más importantes.',
        sections: [
          {
            heading: 'Qué revisar antes de comprar',
            paragraph: 'Con artículos variados, una lista de comprobación constante es tu mejor herramienta.',
            bullets: [
              'Aclara exactamente qué incluye el anuncio',
              'Pregunta por material, estado y dimensiones',
              'Compara el precio con artículos similares',
            ],
          },
          {
            heading: 'Evaluar artículos menos comunes',
            paragraph: 'Cuando un artículo es inusual, las descripciones vagas son un riesgo mayor. Haz preguntas directas y pide fotos claras antes de decidirte, ya que tienes menos referencias en las que apoyarte.',
          },
        ],
        faq: [
          { q: '¿Cómo evalúo un artículo inusual?', a: 'Usa la misma lista de comprobación que en cualquier compra: aclara qué incluye, pregunta por material y estado, y compara precios.' },
          { q: '¿Debo pedir más fotos?', a: 'Sí. Las fotos claras y específicas son especialmente útiles para artículos menos comunes donde tienes menos referencias.' },
          { q: '¿Y si la descripción es vaga?', a: 'Trata una descripción vaga como motivo para hacer más preguntas antes de pedir, en lugar de asumir lo mejor.' },
        ],
        conclusion: 'Aplica las mismas comprobaciones cuidadosas a la categoría de "otras cosas", e incluso los artículos desconocidos se vuelven una compra segura en lugar de un salto de fe.',
      },
      fr: {
        title: 'Autres articles dans le spreadsheet USFANS : quoi vérifier avant d\u2019acheter',
        metaDescription: 'Un guide ciblé sur la catégorie autres articles du spreadsheet USFANS : comment évaluer les articles moins courants et vérifier les détails avant de commander.',
        excerpt: 'Comment évaluer les articles moins courants et vérifier les détails avant d\u2019acheter.',
        intro: 'La catégorie « autres articles » est un fourre-tout pour les objets qui n\u2019entrent nulle part ailleurs. Comme elle est très variée, les mêmes vérifications claires — matière, état, taille et prix — deviennent encore plus importantes.',
        sections: [
          {
            heading: 'Quoi vérifier avant d\u2019acheter',
            paragraph: 'Avec des articles variés, une liste de contrôle constante est votre meilleur outil.',
            bullets: [
              'Clarifiez exactement ce qui est inclus dans l\u2019annonce',
              'Demandez la matière, l\u2019état et les dimensions',
              'Comparez le prix avec des articles similaires',
            ],
          },
          {
            heading: 'Évaluer les articles moins courants',
            paragraph: 'Quand un article est inhabituel, les descriptions vagues sont un risque plus grand. Posez des questions directes et demandez des photos claires avant de vous engager, car vous avez moins de repères.',
          },
        ],
        faq: [
          { q: 'Comment évaluer un article inhabituel ?', a: 'Utilisez la même liste de contrôle que pour tout achat : clarifiez ce qui est inclus, demandez la matière et l\u2019état, et comparez les prix.' },
          { q: 'Dois-je demander plus de photos ?', a: 'Oui. Des photos claires et précises sont particulièrement utiles pour les articles moins courants où vous avez moins de repères.' },
          { q: 'Et si la description est vague ?', a: 'Traitez une description vague comme une raison de poser plus de questions avant de commander, plutôt que de supposer le meilleur.' },
        ],
        conclusion: 'Appliquez les mêmes vérifications soigneuses à la catégorie « autres articles », et même les objets peu familiers deviennent un achat confiant plutôt qu\u2019un saut dans l\u2019inconnu.',
      },
      pl: {
        title: 'Inne rzeczy w arkuszu USFANS: co sprawdzić przed zakupem',
        metaDescription: 'Przewodnik skupiony na kategorii inne rzeczy w arkuszu USFANS: jak oceniać mniej typowe przedmioty i weryfikować detale przed zamówieniem.',
        excerpt: 'Jak oceniać mniej typowe przedmioty i weryfikować detale przed zakupem.',
        intro: 'Kategoria „inne rzeczy" to zbiór przedmiotów, które nie pasują nigdzie indziej. Ponieważ jest bardzo zróżnicowana, te same jasne kontrole — materiał, stan, rozmiar i cena — stają się jeszcze ważniejsze.',
        sections: [
          {
            heading: 'Co sprawdzić przed zakupem',
            paragraph: 'Przy zróżnicowanych przedmiotach stała lista kontrolna to Twoje najlepsze narzędzie.',
            bullets: [
              'Doprecyzuj, co dokładnie zawiera ogłoszenie',
              'Zapytaj o materiał, stan i wymiary',
              'Porównaj cenę z podobnymi przedmiotami',
            ],
          },
          {
            heading: 'Ocena mniej typowych przedmiotów',
            paragraph: 'Gdy przedmiot jest nietypowy, niejasne opisy to większe ryzyko. Zadawaj bezpośrednie pytania i proś o wyraźne zdjęcia przed decyzją, bo masz mniej punktów odniesienia.',
          },
        ],
        faq: [
          { q: 'Jak ocenić nietypowy przedmiot?', a: 'Użyj tej samej listy kontrolnej co przy każdym zakupie: doprecyzuj zawartość, zapytaj o materiał i stan oraz porównaj ceny.' },
          { q: 'Czy prosić o więcej zdjęć?', a: 'Tak. Wyraźne, konkretne zdjęcia są szczególnie przydatne przy mniej typowych przedmiotach, gdzie masz mniej punktów odniesienia.' },
          { q: 'Co, jeśli opis jest niejasny?', a: 'Traktuj niejasny opis jako powód do zadania większej liczby pytań przed zamówieniem, zamiast zakładać najlepsze.' },
        ],
        conclusion: 'Zastosuj te same staranne kontrole do kategorii „inne rzeczy", a nawet nieznane przedmioty staną się pewnym zakupem zamiast skoku w nieznane.',
      },
    },
  },
];